export default __webpack_public_path__ + "static/media/behance.63157a93.svg";